import { FEATURES_SOURCE_MAP } from '../pages/PageFeatures/PageFeatures.const';



const getFeatureSourceKey  = (sourceValue) => Object.keys(FEATURES_SOURCE_MAP).find((key) => FEATURES_SOURCE_MAP[key] === sourceValue);

export default getFeatureSourceKey;
